export type Currency = {
  id: string;
  name: string;
  iconUrl: string;
  isCrypto: boolean;
  metadata: Record<string, string>;
};

export type Country = {
  id: string;
  name: string;
  flagUrl?: string;
  currency: Currency | null;
  regionRequired: boolean;
  regions: Region[];
};

export interface GetCountriesParams {
  list?: LocationListType;
  includeRegions?: boolean;
}

export const LocationList = {
  PASSPORT: 'passport',
  INCORPORATION: 'incorporation',
  ADDRESS: 'address',
} as const;

export type LocationListType = (typeof LocationList)[keyof typeof LocationList];

export type Region = {
  id: string;
  name: string;
};
